import { Button, CellSimple, Counter } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

const PlaceholderAvatar = () => (
  <div style={{ width: 40, height: 40, borderRadius: "50%", background: "var(--tg-theme-hint-color, #aaa)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 16 }}>
    A
  </div>
)

export const CellSimpleExample = {
  title: "CellSimple",
  defaultPlatform: "ios",
  defaultZoom: 100,

  controls: [
    {
      name: "title",
      label: "title",
      type: "text",
      tsType: "ReactNode",
      default: "Title",
    },
    {
      name: "subtitle",
      label: "subtitle",
      type: "text",
      tsType: "ReactNode",
      default: "Subtitle",
    },
    {
      name: "overline",
      label: "overline",
      type: "text",
      tsType: "ReactNode",
      default: "",
      placeholder: "overline",
    },
    {
      name: "height",
      label: "height",
      type: "enum",
      tsType: ['"compact"', '"normal"'],
      default: "normal",
      options: ["compact", "normal"],
    },
    {
      name: "showChevron",
      label: "showChevron",
      type: "boolean",
      tsType: "boolean",
      default: false,
    },
    {
      name: "disabled",
      label: "disabled",
      type: "boolean",
      tsType: "boolean",
      default: false,
    },
    {
      name: "before",
      label: "before",
      type: "select",
      tsType: "ReactNode",
      default: "Icon",
      options: [
        { value: "Icon", label: "Icon" },
        { value: "Avatar", label: "Avatar" },
        { value: "none", label: "None" },
      ],
    },
    {
      name: "after",
      label: "after",
      type: "select",
      tsType: "ReactNode",
      default: "Button",
      options: [
        { value: "Button", label: "Button" },
        { value: "Counter", label: "Counter" },
        { value: "none", label: "None" },
      ],
    },
    {
      name: "innerClassNames",
      label: "innerClassNames",
      type: "static",
      tsType: "InnerClassNamesProp<CellSimpleInnerElementKey>",
      value: "-",
    },
    {
      name: "asChild",
      label: "asChild",
      type: "static",
      tsType: "boolean",
      value: "-",
    },
    {
      name: "as",
      label: "as",
      type: "static",
      tsType: "ElementType",
      value: "-",
    },
    {
      name: "onClick",
      label: "onClick",
      type: "static",
      tsType: "function",
      value: "-",
    },
  ],

  Preview({ props }) {
    const beforeNode =
      props.before === "Icon" ? <PlaceholderIcon /> :
      props.before === "Avatar" ? <PlaceholderAvatar /> :
      undefined

    const afterNode =
      props.after === "Button" ? <Button key="icon" variant="secondary" size="small">Открыть</Button> :
      props.after === "Counter" ? <Counter key="counter" value={1200} /> :
      undefined

    return (
      <CellSimple
        after={afterNode}
        before={beforeNode}
        height={props.height}
        overline={props.overline || undefined}
        subtitle={props.subtitle}
        title={props.title}
        showChevron={props.showChevron}
        disabled={props.disabled}
      />
    )
  },

  getCode(props) {
    const lines = []
    if (props.before === "Icon") lines.push(`  before={<Icon24Placeholder />}`)
    else if (props.before === "Avatar") lines.push(`  before={<Icon24Placeholder />}`)

    if (props.after === "Button") lines.push(`  after={<Button key="icon" variant="secondary" size="small">Открыть</Button>}`)
    else if (props.after === "Counter") lines.push(`  after={<Counter key="counter" value={1200}/>}`)

    if (props.height !== "normal") lines.push(`  height="${props.height}"`)
    if (props.overline) lines.push(`  overline="${props.overline}"`)
    if (props.showChevron) lines.push(`  showChevron`)

    const propsStr = lines.length > 0 ? "\n" + lines.join("\n") + "\n" : ""
    return `<CellSimple${propsStr}
  subtitle="${props.subtitle}"
  title="${props.title}"
/>`
  },
}